import React from 'react';
import { CBadge, CButton, CDataTable } from '@coreui/react';
import moment from 'moment';
import { useHistory, useRouteMatch } from 'react-router-dom';
import { connect } from 'react-redux';
import { JobsUploadStatus, TransformedUpload, UploadStatus } from '../../shared/models/jobs';
import { RootState } from '../../store/state';

export interface UploadListProps {
  uploads: JobsUploadStatus[];
}

const UploadList = (props: UploadListProps) => {
  const { uploads } = props;

  const history = useHistory();
  const { path } = useRouteMatch();

  const handleClick = (id: string) => () => {
    history.push(`${ path }/${ id }`);
  };

  const transformedUploads = uploads?.map(upload => ({
    id: upload.id,
    status: upload.status,
    created: upload.created,
    updated: upload.updated,
    processedRows: upload.task_data?.processed,
    erroredRows: upload.task_data?.errored,
    totalRows: upload.task_data?.total,
  } as TransformedUpload)).sort((a, b) => b.id.localeCompare(a.id))

  return (
    <CDataTable
      items={ transformedUploads }
      fields={[
        'status',
        {
          key: 'processedRows',
          label: 'Processed Rows',
          _classes: 'text-center',
        },
        {
          key: 'erroredRows',
          label: 'Errored Rows',
          _classes: 'text-center',
        },
        {
          key: 'totalRows',
          label: 'Total Rows',
          _classes: 'text-center',
        },
        'created',
        {
          key: 'updated',
          label: 'Last Updated',
        },
        {
          key: 'select',
          label: '',
          sorter: false,
          filter: false,
        },
      ]}
      hover
      striped
      scopedSlots={{
        status: ({ status, erroredRows }: TransformedUpload) => {
          let badge;
          switch (status) {
            case UploadStatus.Created:
              badge = <CBadge color="secondary">Created</CBadge>;
              break;
            case UploadStatus.Processing:
              badge = <CBadge color='info'>Processing</CBadge>;
              break;
            case UploadStatus.Done:
              badge = <CBadge color='success'>Done { erroredRows > 0 ? 'With Errors' : '' }</CBadge>;
              break;
            case UploadStatus.Error:
              badge = <CBadge color='danger'>Error</CBadge>;
              break;
            default:
              badge = <CBadge color='secondary'>Unknown</CBadge>;
              break;
          }

          return (
            <td>
              { badge }
            </td>
          );
        },
        created: ({ created }: TransformedUpload) => (
          <td>
            { moment.unix(created).format('l LTS') }
          </td>
        ),
        updated: ({ updated }: TransformedUpload) => (
          <td>
            { moment.unix(updated).format('l LTS') }
          </td>
        ),
        select: ({ id }: TransformedUpload) => {
          return (
            <td>
              <CButton color='primary' className='bg-color-orange float-right roundedBtn' onClick={ handleClick(id) }>Review</CButton>
            </td>
          );
        },
      }}
    />
  );
};

const mapStateToProps = (state: RootState) => ({
  uploads: state?.jobs?.uploads?.data,
});

export default connect(mapStateToProps)(UploadList);